// extracted by mini-css-extract-plugin
module.exports = {"root":"OcGby89EtOcH_csODtZnb","title":"UAbIDgQDvtgi5jb9cMV-V","left":"i_ji_sRwHK1a3TeZ7o-ZI","right":"_2rvzYlSw8O5s5-g7h5rVOJ","text-margin-resend":"_3C6vP8dmiCSJjKvbf49x8Y"};